import { API_PREFIX } from "./endpoints.js";
const API = API_PREFIX;
export const urls = {
    GET_FISHFARM_OWNERS: `${API}/getFishFarmOwners`,
    GET_DISEASE_ZONES: `${API}/getDiseaseZones`,
    GET_FISH_INFO: `${API}/getFishInfo`,
};
//# sourceMappingURL=urls.js.map